import isMiddleware from "@/router/middleware/isMiddleware";

const needle = "person_access_to_view";

export default function (to, from, next) {
    const rule = to.meta["middleware"];
    if (!rule || !isMiddleware(needle, rule)) return false;

    if (!from.meta.hash)
        return next({
            name: "persons.access",
            params: {
                ...to.params,
                id: to.params.id,
            },
            query: to.query,
            hash: to.hash,
        });
    to.meta.hash = from.meta.hash;

    return false;
}
